import { useSelector } from 'react-redux';
import type { IGenre } from 'services/api/entities';
import {
  selectMicroGenre,
  selectPrimaryGenre,
} from 'services/store/ai/selectors';
import useGenre from '../../../../useGenre';
import { DEFAULT_BPM_RANGE } from './constants';

type UseBpmSelector = {
  recommendedBpmRange: IGenre['recommendedBpm'];
};

const useBpmSelector = (): UseBpmSelector => {
  const primaryGenre = useSelector(selectPrimaryGenre);
  const microGenre = useSelector(selectMicroGenre);

  const genreData = useGenre(primaryGenre, microGenre);

  return {
    recommendedBpmRange: genreData?.recommendedBpm ?? DEFAULT_BPM_RANGE,
  };
};

export default useBpmSelector;
